
///Mobile Navigation V2
const headerMobileDrawer = document.querySelector("#HeaderMobileV2");
const headerMobile = headerMobileDrawer.querySelector(".header-mobile__container");
const isVisibleClass = 'is-visible'

if (headerMobile) {
  const headerMobileWrapper = headerMobile.querySelector(".header-mobile__wrapper");
  const level1Nav = headerMobileWrapper.querySelector(".level-1");
  const level1Tabs = level1Nav.querySelectorAll(".main-menu > div > li");

  // function resetMobileNav() {
  //   mobileNavWrapper.querySelectorAll(".level-2").forEach((subnav) => {
  //     if (subnav.classList.contains(isVisibleClass)) {
  //       const backBtn = subnav.querySelector(".back-level1");
  //       backBtn.click();
  //     }
  //   })
  //   level1Nav.scrollTop = 0;
  // }

  // Navigation Lv1 to Lv2
  level1Tabs.forEach((tab) => {
    tab.addEventListener("click", (e) => {
      // e.preventDefault();
      const handle = tab.getAttribute("data-menu");
      const subnav = headerMobileWrapper.querySelector(`[data-submenu="${handle}"]`);
      if (subnav) {
        // Active img data-src
        const imgTags = subnav.querySelectorAll('img');
        imgTags.forEach(img => {
          // Check if the image has a src attribute
          const datraSRC = img.getAttribute("data-src");
          if (!img.src && datraSRC) {
            img.src = datraSRC;
          }
        });

        level1Nav.classList.remove(isVisibleClass)
        subnav.classList.add(isVisibleClass)
        // level1Nav.scrollTop = 0;
      }
    });
  });

  // Navigation Lv2 to Lv1
  const backBtns = headerMobileWrapper.querySelectorAll(".back-level1");
  backBtns.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const subnav = btn.closest(".level-2");
      if (subnav) {
        subnav.classList.remove(isVisibleClass)
        level1Nav.classList.add(isVisibleClass)
        sublistTabs = subnav.querySelectorAll('.header-mobile__submenu__item')
        sublistTabs.forEach(tab => {
          tab.classList.remove('open')
        })
        subnav.scrollTop = 0;
      }
    });
  });

  // Lv2 Submenu toggle
  const leverl3Toggles = headerMobileDrawer.querySelectorAll('.header-mobile__submenu__item')
  leverl3Toggles.forEach(toggle => {
    const itemTitleBtn = toggle.querySelector('.js-submenu-title-btn')
    const itemLinks = toggle.querySelector('.header-mobile__submenu__item__links')
    if (itemTitleBtn && itemLinks) {
      itemTitleBtn.addEventListener('click', function () {
        if (toggle.classList.contains('open')) {
          toggle.classList.remove('open')
        } else {
          toggle.classList.add('open')
        }
      })
    }
  })
}

